import React from 'react';
import { Block, BlockVariant, Recipe, ParsedResponse } from '../types';

export interface BaseBlockProps {
  id: string;
  name: string;
  description: string;
  recipe: Recipe;
  variants: BlockVariant[];
  parser: (content: string) => ParsedResponse<any>;
  renderer: (props: any) => React.ReactNode;
}

export function createBaseBlock({
  id,
  name,
  description,
  recipe,
  variants,
  parser,
  renderer,
}: BaseBlockProps): Block {
  return {
    id,
    name,
    description,
    recipe,
    variants,
    parser,
    renderer,
  };
}

// Example usage:
/*
const themeBlock = createBaseBlock({
  id: 'theme',
  name: 'Theme Block',
  description: 'Displays theme information with activity metrics',
  recipe: themeRecipe,
  variants: [
    {
      id: 'default',
      name: 'Default',
      description: 'Standard theme display',
      defaultSettings: {
        showMetrics: true,
        showKeywords: true,
      },
    },
    {
      id: 'compact',
      name: 'Compact',
      description: 'Minimal theme display',
      defaultSettings: {
        showMetrics: false,
        showKeywords: true,
      },
    },
  ],
  parser: themeParser,
  renderer: ThemeBlockRenderer,
});
*/ 